import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {catchError, map, Observable, throwError} from "rxjs";
import {ReportRemito} from "../models/ReportRemito";
import {Remito} from "../models/Remito";
import {Origen} from "../models/Origen";

@Injectable({
  providedIn: 'root'
})
export class IssuedRemitosReportService {
  private readonly url = environment.reportUrl;

  private readonly commonDataUrl = environment.CommonDataUrl;

  remitoParams: HttpParams;

  constructor(private readonly httpClient: HttpClient) { }


  public generateReport(remito: Remito): Observable<ReportRemito[]> {

    this.getSearchParams(remito);

    return this.httpClient.get<ReportRemito[]>(this.url+'/all_issued_remitos', { params: this.remitoParams }).pipe(map(
        allData => {
          return allData.map((allData) => {
            return ReportRemito.transformData(allData);
          })
        }),
      catchError(this.handleError));
  }


  getSearchParams(remito: Remito) {

    this.remitoParams = new HttpParams();

    this.remitoParams = this.remitoParams.append('origen', remito.origen);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('ptoEmision', remito.ptoEmision);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('nroShipper', remito.nroShipper);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('nroRemitoStart', remito.nroRemito);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('nroRemitoEnd', remito.nroRemitoEnd);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('codDealer', remito.codDealer)
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('nombreDealer', remito.nombreDealer)
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('codAlmacen', remito.codAlmacen)
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('descAlmacen', remito.descAlmacen)
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('fecGen', remito.fecGenStart);
    // @ts-ignore
    this.remitoParams = this.remitoParams.append('fecGenEnd', remito.fecGenEnd);

  }


  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getOrigins() {
    return this.httpClient.get<Origen[]>(this.commonDataUrl+ '/origins' );
  }

  downloadPdf(remito: Remito): Observable<Blob>  {
    this.getSearchParams(remito);
    return this.httpClient.get(this.url + '/pdf/download/all_issued_remitos', {params: this.remitoParams, responseType: 'blob'}).pipe(catchError(this.parseErrorBlob));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    let jsonError="";
    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        console.log(JSON.parse((<any>e.target).result));
        observer.error(JSON.parse((<any>e.target).result));
        // alert("Error:\n" + (<any>e.target).result);
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }
}
